(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }

  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;

      var newRecommendations = container.querySelector(".product-recommendations");
      if (!newRecommendations) {
        console.error('No .product-recommendations found in AJAX response');
        return;
      }

      productRecommendationsSection.innerHTML = newRecommendations.innerHTML;

      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();

      var carousel = productRecommendationsSection.querySelector('.ab-recommendation-carousel');
      if (carousel) {
        initializeEmblaAfterImagesLoad(carousel);
      } else {
        console.warn('Carousel element not found after AJAX load');
      }
    } else {
      console.error('Failed to load recommendations:', request.statusText);
    }
  };
  request.onerror = function() {
    console.error('Network error while loading recommendations');
  };
  request.send();
};


// 이미지가 모두 로드된 후 Embla 초기화하는 함수
function initializeEmblaAfterImagesLoad(carousel) {
  const images = carousel.querySelectorAll('img');
  let loadedCount = 0;

  if (images.length === 0) {
    initializeEmbla(carousel);
    return;
  }

  images.forEach((img) => {
    if (img.complete) {
      loadedCount++;
    } else {
      img.addEventListener('load', () => {
        loadedCount++;
        if (loadedCount === images.length) {
          initializeEmbla(carousel);
        }
      });
      img.addEventListener('error', () => {
        loadedCount++;
        if (loadedCount === images.length) {
          initializeEmbla(carousel);
        }
      });
    }
  });

  if (loadedCount === images.length) {
    initializeEmbla(carousel);
  }
}

// Embla 초기화 함수 (옵션 안정화)
function initializeEmbla(carousel) {
  EmblaCarousel(carousel, {
    align: 'start',
    dragFree: true,
    containScroll: 'trimSnaps',  // 기존 잘 되는 옵션으로 통일
    loop: false,
    skipSnaps: true,
  });
}


// 페이지 로드 시 초기 호출
loadProductRecommendationsIntoSection();

// 섹션 리로드 이벤트 대응
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});

// ㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡ
// var loadProductRecommendationsIntoSection = function() {
//   var productRecommendationsSection = document.querySelector(".product-recommendations");
//   if (productRecommendationsSection === null) { return; }

//   var request = new XMLHttpRequest();
//   request.open("GET", productRecommendationsSection.dataset.url);
//   request.onload = function() {
//     if (request.status >= 200 && request.status < 300) {
//       var container = document.createElement("div");
//       container.innerHTML = request.response;
//       productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

//       theme.ProductBlockManager.loadImages(productRecommendationsSection);
//       theme.initAnimateOnScroll();

//       // Embla 초기화
//       var carousel = productRecommendationsSection.querySelector('.ab-recommendation-carousel');
//       if (carousel) {
//         EmblaCarousel(carousel, {
//           align: 'start',
//           dragFree: true,
//           containScroll: false,
//           loop: false,
//           skipSnaps: true,
//         });

//       } else {
//         console.warn('Carousel element not found after AJAX load');
//       }
//     } else {
//       console.error('Failed to load recommendations:', request.statusText);
//     }
//   };
//   request.onerror = function() {
//     console.error('Network error while loading recommendations');
//   };
//   request.send();
// };

// // 페이지 로드 시 초기 호출
// loadProductRecommendationsIntoSection();

// // 섹션 리로드 이벤트 대응
// document.addEventListener("shopify:section:load", function(event) {
//   if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
//     loadProductRecommendationsIntoSection();
//   }
// });


// ㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡ

// var loadProductRecommendationsIntoSection = function() {
//   // Look for an element with class 'product-recommendations'
//   var productRecommendationsSection = document.querySelector(".product-recommendations");
//   if (productRecommendationsSection === null) { return; }
//   // Create request and submit it using Ajax
//   var request = new XMLHttpRequest();
//   request.open("GET", productRecommendationsSection.dataset.url);
//   request.onload = function() {
//     if (request.status >= 200 && request.status < 300) {
//       var container = document.createElement("div");
//       container.innerHTML = request.response;
//       productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
//       theme.ProductBlockManager.loadImages(productRecommendationsSection);
//       theme.initAnimateOnScroll();
//     }
//   };
//   request.send();
// };
// // fetch when section reloads in editor
// document.addEventListener("shopify:section:load", function(event) {
//   if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
//     loadProductRecommendationsIntoSection();
//   }
// });
// // Fetching the recommendations on page load
// loadProductRecommendationsIntoSection();


  } catch(e) { console.error(e); }
})();
})();
